import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/lib/auth'
import Dashboard from '@/pages/Dashboard'
import BusinessesList from '@/pages/BusinessesList'
import BusinessForm from '@/pages/BusinessForm'
import EmiratesList from '@/pages/EmiratesList'
import ServicesList from '@/pages/ServicesList'
import LanguagesList from '@/pages/LanguagesList'
import PaymentMethodsList from '@/pages/PaymentMethodsList'
import UsersList from '@/pages/UsersList'
import Login from '@/pages/Login'
import type { ReactNode } from 'react'

function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50">
        <div className="text-slate-500">Loading...</div>
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

function AppRoutes() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50">
        <div className="text-slate-500">Loading...</div>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/businesses" element={<ProtectedRoute><BusinessesList /></ProtectedRoute>} />
      <Route path="/businesses/:id" element={<ProtectedRoute><BusinessForm /></ProtectedRoute>} />
      <Route path="/emirates" element={<ProtectedRoute><EmiratesList /></ProtectedRoute>} />
      <Route path="/services" element={<ProtectedRoute><ServicesList /></ProtectedRoute>} />
      <Route path="/languages" element={<ProtectedRoute><LanguagesList /></ProtectedRoute>} />
      <Route path="/payment-methods" element={<ProtectedRoute><PaymentMethodsList /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute><UsersList /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
